import React, { Component } from 'react'
import Select, { components } from 'react-select'
import { Label } from 'components/UI/Label'
import OutsideClick from 'components/UI/OutsideClick'
import { Tooltip } from 'components/UI/Tooltip'
import { TimesCircleIcon, ChevronDownIcon } from 'components/icons'
import { debounce } from 'utils/debounce'
import selectStyles from './select.styles'
import {
  Wrapper,
  ArrowBlock,
  MainButton,
  Menu,
  StyledDropdown,
  StyledIndicator,
  LabelWrap,
  TooltipWrap
} from './styles'
import { Props } from 'components/content/Header'
import { optionCSS } from 'react-select/src/components/Option'

export interface Option {
  label?: string
  value?: any
}

export interface DropdownProps {
  id?: string
  name: string
  options?: Option[]
  label?: string
  tooltipText?: string
  placeholder?: string
  hideControl?: boolean
  onInputChange?: (value: string) => void
  value?: any
  onSelect?: (name: string, value: string) => void
  onScrollToBottom?: (searchText?: any) => void
  isBigData?: boolean
}

interface DropdownState {
  isOpen: boolean
  option: Option
  bottom: boolean
  data: []
  searchText: string
}

// @ts-ignore
const DropdownIndicator = props => (
  <StyledIndicator hidden={props.selectProps.inputValue}>
    <components.DropdownIndicator {...props}>
      <TimesCircleIcon width={'1rem'} heith={'1rem'} fill={'#e3e7ed'} />
    </components.DropdownIndicator>
  </StyledIndicator>
)

// @ts-ignore
const Dropdown = ({ children, isOpen, target, onClose }) => (
  <StyledDropdown>
    <OutsideClick onOutsideClick={onClose}>
      {target}
      {isOpen ? <Menu id="menu">{children}</Menu> : null}
    </OutsideClick>
  </StyledDropdown>
)

class DropdownSelect extends Component<DropdownProps, DropdownState> {
  public static defaultProps = {
    hideControl: false
  }

  constructor(props: DropdownProps) {
    super(props)

    this.state = {
      isOpen: false,
      option: props.value ? props.value : { label: '' },
      bottom: false,
      data: [],
      searchText: ''
    }
    this.onInputChange = debounce(this.onInputChange.bind(this), 400)
  }

  componentDidUpdate(prevProps: DropdownProps, prevState: DropdownState) {
    if (!prevProps.value && this.props.value) {
      this.setState({ option: this.props.value })
    }
    if (prevProps.value !== this.props.value) {
      this.setState({ option: this.props.value })
    }
    const listContainer = document.getElementById('menu')
    if (listContainer) {
      // css-g8losv-MenuList css-4ro4f9-menu
      const menuList = listContainer.querySelector('.css-g8losv-MenuList')
      // console.log('menu', menu)
      if (menuList) {
        menuList.addEventListener('scroll', e => {
          if (menuList) {
            // console.log('test', {
            //   scrollTop: menuList.scrollTop,
            //   scrollHeight: menuList.scrollHeight,
            //   LisOffsetHeight: listContainer.offsetHeight,
            //   minus: menuList.scrollHeight - listContainer.offsetHeight
            // })
            if (
              menuList.scrollTop >=
              menuList.scrollHeight - listContainer.offsetHeight
            ) {
              // this.setState({ bottom: true })
              if (this.state.searchText) {
                this.onBottomCallback(this.state.searchText)
              } else {
                this.onBottomCallback()
              }
            }
          }
        })
      }
    }
  }

  // @ts-ignore
  filterOption = ({ label, value, data }, query: string): boolean =>
    !query ||
    (value !== 'all' &&
      !data.isDisabled &&
      label.toLowerCase().includes(query.toLowerCase()))

  toggleOpen = () => this.setState(state => ({ isOpen: !state.isOpen }))
  closeOpen = () => this.setState({ isOpen: false })

  onSelectChange = (option: Option) => {
    const { onSelect, name, options } = this.props
    // if (options && options.filter(({ value }) => option.value === value).length === 0) {return;}
    console.log(option)
    this.toggleOpen()

    this.setState({ option }, () => {
      if (onSelect) {
        // @ts-ignore
        onSelect(name, option)
      }
    })
  }

  // @ts-ignore
  onInputChange = (query: string, { action }) => {
    const { onInputChange: onChange } = this.props
    // Prevents resetting our input after option has been selected

    if (action !== 'set-value') {
      if (onChange) {
        this.setState({ searchText: query })
        onChange(query)
      }
      // this.setState({inputValue: query});
    }
  }

  onBottomCallback = (searchText?: string) => {
    const { onScrollToBottom } = this.props
    if (onScrollToBottom) {
      searchText ? onScrollToBottom(searchText) : onScrollToBottom()
    }
  }

  render() {
    const {
      placeholder,
      options,
      label,
      id,
      hideControl,
      tooltipText,
    } = this.props
    const { isOpen, option } = this.state
    const styles = selectStyles({ hideControl })
    return (
      <Wrapper isSelected={isOpen}>
        <LabelWrap>
          {!!label && (
            <div>
              <Label htmlFor={id}>{label}</Label>
            </div>
          )}
          {tooltipText && (
            <TooltipWrap>
              <Tooltip text={tooltipText} />
            </TooltipWrap>
          )}
        </LabelWrap>

        <Dropdown
          isOpen={isOpen}
          onClose={this.closeOpen}
          target={
            // @ts-ignore
            <MainButton
              type="button"
              onClick={this.toggleOpen}
              isSelected={isOpen}
            >
              {option && option.label ? option.label : placeholder}
              <ArrowBlock>
                <ChevronDownIcon />
              </ArrowBlock>
            </MainButton>
          }
        >
          {/*{bottom && data ? (*/}
          {/*  <span>Loading...</span>*/}
          {/*) : (*/}
          <Select
            autoFocus={true}
            components={{
              DropdownIndicator,
              IndicatorSeparator: null
            }}
            isClearable={false}
            menuIsOpen={true}
            openMenuOnClick={false}
            openOnClick={false}
            openAfterFocus={false}
            openOnFocus={false}
            closeMenuOnSelect={true}
            onSelectResetsInput={true}
            controlShouldRenderValue={false}
            backspaceRemovesValue={false}
            // @ts-ignore
            onChange={this.onSelectChange}
            onInputChange={this.onInputChange}
            options={options} // isBigData ? data :
            placeholder={placeholder}
            styles={styles}
            tabSelectsValue={false}
            value={option}
            filterOption={this.filterOption}
          />
          {/*)}*/}
        </Dropdown>
      </Wrapper>
    )
  }
}

export default DropdownSelect
